import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-capital-social',
  templateUrl: './consulta-capital-social.component.html',
  styleUrls: ['./consulta-capital-social.component.scss']
})
export class ConsultaCapitalSocialComponent implements OnInit {

  title = "CAPITAL SOCIAL";
  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
